import React from 'react'

import OmieIcon from '../_assets/OmieIcon'
import NiboIcon from '../_assets/NiboIcon'

export const INTEGRATION_LOGO = {
  omie: <OmieIcon />,
  nibo: <NiboIcon />
}
